/**
 * @method waitForDocumentContent
 * @param {Function} getFrame - function that returns an iframe element
 * @returns {Promise} promise that resolves when the frame's body is replaced
 */
const waitForDocumentContent = (getFrame) => {
  const frame = getFrame();
  const originalBody = frame?.contentDocument?.body;

  return new Promise((resolve, reject) => {
    let checkInterval, resolveAfterTimeout;

    const succeed = () => {
      // Cease timed functions, otherwise they will continue after this promise has resolved.
      clearInterval(checkInterval);
      clearTimeout(resolveAfterTimeout);

      resolve();
    };

    const check = () => {
      const frame = getFrame();

      if (!frame) {
        return reject(
          'frame is gone: this is expected if the user navigates to another document while loading.',
        );
      }

      // For most titles, we can expect the frame body to be replaced with a new element.
      const frameHasNewBodyElement =
        frame.contentDocument?.body !== originalBody &&
        frame.contentDocument?.body !== null;

      if (frameHasNewBodyElement) {
        succeed();
      }
    };

    // Run a check every 100ms for document content changes.
    checkInterval = setInterval(check, 100);

    /**
     * After 10 seconds, show whatever is in the iframe.
     *
     * In a worst case scenario it will show nothing or it will show an error.
     *
     * But it will also show the content as desired if there is an edge case where
     * the content resolving is not detected by any of the checks that would have it resolve sooner.
     */
    resolveAfterTimeout = setTimeout(succeed, 10000);
  });
};

export default waitForDocumentContent;
